import { createIcon } from '@chakra-ui/icons';

export const CakeIcon = createIcon({
  displayName: 'CakeIcon',
  viewBox: '0 0 24 24',
  path: [
    <path
      key={1}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.00226 19.5938V21.2542C3.00226 23.2117 2.84176 23.9167 5.22526 23.9167H18.5903C20.9723 23.9167 20.8103 23.2102 20.8103 21.2542V19.5938H3.00226Z"
      fill="currentColor"
    />,
    <path
      key={2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4.5H7.4025V9.108H6V4.5Z"
      fill="currentColor"
    />,
    <path
      key={3}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 4.5H12V8.9535H10.5V4.5Z"
      fill="currentColor"
    />,
    <path
      key={4}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 4.5H17.985V8.7765H16.5V4.5Z"
      fill="currentColor"
    />,
    <path
      key={5}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.44704 1.46234C7.59704 2.07134 7.36004 2.77184 6.79154 2.83484C6.26054 2.89484 5.85404 2.20934 6.26204 1.52984C6.68054 0.839844 6.79154 0.0898438 6.79154 0.0898438C6.79154 0.0898438 7.27154 0.730344 7.44704 1.46234Z"
      fill="currentColor"
    />,
    <path
      key={6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.908 1.53187C12.0655 2.17087 11.8165 2.90887 11.2045 2.97487C10.633 3.03787 10.1965 2.31637 10.6375 1.60387C11.0875 0.876367 11.2045 0.0888672 11.2045 0.0888672C11.2045 0.0888672 11.7175 0.763867 11.908 1.53187Z"
      fill="currentColor"
    />,
    <path
      key={7}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9605 1.53427C18.1285 2.17327 17.8615 2.90827 17.2135 2.97427C16.6075 3.03727 16.1425 2.31727 16.612 1.60477C16.9076 1.14398 17.1118 0.630668 17.2135 0.0927734C17.2135 0.0927734 17.758 0.767774 17.9605 1.53427Z"
      fill="currentColor"
    />,
    <path
      key={10}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7197 12.6554C5.3422 12.6554 6.2437 12.0644 6.5092 11.8574C6.5167 11.8484 7.5997 10.8314 8.9122 10.8314C10.2187 10.8314 11.3467 11.8394 11.3932 11.8829C11.6362 12.0929 12.4402 12.6554 13.1542 12.6554C13.9972 12.6554 14.8162 11.8979 14.8162 11.8979C14.8762 11.8409 15.9967 10.8314 17.3482 10.8314C18.7057 10.8314 19.7872 11.8484 19.8322 11.8919C20.0737 12.0989 20.5282 12.4034 20.9377 12.5549C20.8912 10.6034 19.9942 9.04492 17.6737 9.04492H6.3892C4.3027 9.04492 3.3622 10.3004 3.1582 11.9684C3.4957 12.2189 4.1902 12.6554 4.7197 12.6554Z"
      fill="currentColor"
    />,
    <path
      key={8}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0752 14.2043C19.0482 14.1803 18.2397 13.4258 17.3487 13.4258C16.4502 13.4258 15.6012 14.1863 15.5907 14.1953C15.5517 14.2298 14.4642 15.2453 13.1547 15.2453C11.8572 15.2453 10.6932 14.2448 10.6437 14.2013C10.3992 13.9823 9.62073 13.4258 8.91273 13.4258C8.06973 13.4258 7.25673 14.1803 7.24623 14.1863C7.07373 14.3243 5.84823 15.2453 4.72023 15.2453C4.14123 15.2453 3.56223 15.0068 3.11523 14.7578V17.9183H20.9487V15.1973C20.0322 15.0068 19.1832 14.2958 19.0752 14.2043Z"
      fill="currentColor"
    />,
    <path
      key={9}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 21H23.7765V23.9025H0V21Z"
      fill="currentColor"
    />,
  ],
});
